import { render } from "./DesktopFrame.vue?vue&type=template&id=7728ed2a&scoped=true"
import script from "./DesktopFrame.vue?vue&type=script&lang=js"
export * from "./DesktopFrame.vue?vue&type=script&lang=js"

import "./DesktopFrame.vue?vue&type=style&index=0&id=7728ed2a&lang=scss&scoped=true"

import exportComponent from "/nodeApps/scrawl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7728ed2a"]])

export default __exports__